import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.section`
    display: block;
    width: 100%;
    background-color: ${COLORS.GRAY_XXS};
    padding: 32px 0;
`;

export const Desc = styled.div`
    display: block;
`;

export const HeadTitle = styled.h2`
    ${FONTS.H2};
    color: ${COLORS.black};
    margin-bottom: 8px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3};
    }
`;

export const SubHeadTitle = styled.p`
    ${FONTS.XL};
    color: ${COLORS.black};
    margin-bottom: 32px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.L};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.L};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.S};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.M};
    }
`;

export const NoSsrContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    min-height: 380px;
    -webkit-tap-highlight-color: transparent;

    & > div {
        flex-basis: 30%;

        &:not(:last-child) {
            margin-right: 16px;
        }
    }

    & > section > div.slider-frame > div > div {
        outline: unset;
    }
`;
